"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var LockIcon = function LockIcon(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#333F48' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 20 : _ref$size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.0002 1.66675C7.70266 1.66675 5.8335 3.53591 5.8335 5.83342V7.50008H5.00016C4.081 7.50008 3.3335 8.24758 3.3335 9.16675V16.6667C3.3335 17.5859 4.081 18.3334 5.00016 18.3334H15.0002C15.9193 18.3334 16.6668 17.5859 16.6668 16.6667V9.16675C16.6668 8.24758 15.9193 7.50008 15.0002 7.50008H14.1668V5.83342C14.1668 3.53591 12.2977 1.66675 10.0002 1.66675ZM7.50016 5.83342C7.50016 4.45508 8.62183 3.33341 10.0002 3.33341C11.3785 3.33341 12.5002 4.45508 12.5002 5.83342V7.50008H7.50016V5.83342ZM15.0018 16.6667H10.8335V14.7684C11.3293 14.4792 11.6668 13.9476 11.6668 13.3334C11.6668 12.4142 10.9193 11.6667 10.0002 11.6667C9.081 11.6667 8.3335 12.4142 8.3335 13.3334C8.3335 13.9467 8.671 14.4792 9.16683 14.7684V16.6667H5.00016V9.16675H15.0002L15.0018 16.6667Z",
    fill: color
  }));
};
var _default = LockIcon;
exports.default = _default;